export default __webpack_public_path__ + "static/media/bnb-token-icon.bc62c04d.svg";